import { create } from 'zustand';

const useUserDataStore = create((set) => ({
  userData: null,
  setUserData: (newUserData) => set((state) => ({ ...state, userData: newUserData })),
}));

export default useUserDataStore;

